import {
    SET_PAGE,
    GET_USER,
    SET_PRIMARY_COLOR,
    SET_SECONDARY_COLOR,
    SET_LOGO_URL,
    CREATE_NEW_CONVERSATION,
    GET_USER_CONVERSATIONS_LIST,
    GET_USER_CONVERSATION,
    UPDATE_CONVERSATION_MESSAGES,
    SET_CURRENT_CHANNEL,
    SET_INITIATE_SOCKET_CONNECTION,
    CLEAR_USER_CONVERSATION,
    GET_INITIAL_STATE,
    GET_CHANNEL_ID,
    SET_USER_CONVERSATION_DATA,
    PROCESS_PUSHER_MESSAGES,
    PROCESS_CLIENT_MESSAGES,
    SET_USER_ID,
    SET_BOT_NAME,
    SET_HIDE_COMPANY_DETAILS_IN_WIDGET,
    SET_NETWORK_STATUS,
    UPDATE_SENDING_MESSAGES,
    REMOVE_FROM_SENDING_MESSAGES,
    HANDLE_SENDING_MESSAGES_TO_PUSHER,
    UPDATE_MESSAGE_READ_STATUS,
    UPDATE_MESSAGE_DELIVERED,
    CLEAR_ACTIVE_MESSAGES,
    SET_PARENT_INNER_WIDTH,
    SET_POPUP_TO_NOTIFICATION_MESSAGE,
    SET_INPUT_BOX_STATUS,
    SET_TIME_SPENT,
    SET_AGENT,
    SET_EXTERNAL_TRIGGER_FORMS,
    SET_EXTERNAL_TRIGGER_ELEMENTS,
    SET_IS_MESSAGE_UNREAD,
    SET_IS_PUSHER_CONNECTED,
    SET_READ_NOTIFICATION,
    SET_ACTIVE_PAGE,
    SET_AGENT_NEW_MESSAGE_LIST,
    SET_WIDGET_VISIBILITY,
    HANDLE_WIDGET_EVENT,
    WIDGET_SOUND,
    TEXT_AREA_NUMBER_OF_LINES,
    CLEAR_BOT_ACTIVE_PATH,
    SET_SHOW_TYPING,
    SHOW_TYPING_INDICATOR,
    SET_CLIENT_SENT_TIME,
    SET_SERVER_RESPONSE_TIME,
    RESET_NETWORK_DELAY,
    SET_LINK_IFRAME,
    FETCH_MEETING_SLOTS,
    BOOK_MEETING_SLOT,
    HIDE_REMOVABLE_MESSAGES,
    SET_DELAY_FLAG,
    SET_LANGUAGE,
    SET_SERVER_MESSAGES_QUEUE,
    SET_SEND_GREETING_MESSAGE_ACTION,
    HIDE_RESTART_BUTTON,
    GET_ALL_FILES,
    SET_USER_ATTACHMENTS,
    REMOVE_FROM_CONVERSATION_MESSAGES,
    SET_MAPPED_FORM_FIELDS,
    SET_CUSTOM_COOKIES, HANDLE_SENDING_COOKIES_TO_PUSHER, GET_RECENT_GIFS, GET_TRENDING_GIFS, GET_SEARCHED_GIFS,
} from './constants';
import { defineAction } from 'utils/actionHelper';
import {put} from "redux-saga/effects";



export const bookMeetingSlot = ({payload,meta}) => {
  return defineAction({
    type: BOOK_MEETING_SLOT,
    payload,
    meta
  });
};

export const fetchMeetingSlots = ({meta}) => {
  return defineAction({
    type: FETCH_MEETING_SLOTS,
    meta
  });
};

export const getRecentGifs = {
    start: ({ meta }) => defineAction({ type: GET_RECENT_GIFS.START, meta }),
    success: ({ data }) => defineAction({ type: GET_RECENT_GIFS.SUCCESS, payload: { data } }),
    error: () => defineAction({ type: GET_RECENT_GIFS.ERROR }),
};

export const getTrendingGifs = {
    start: ({ meta }) => defineAction({ type: GET_TRENDING_GIFS.START, meta }),
    success: ({ data }) => defineAction({ type: GET_TRENDING_GIFS.SUCCESS, payload: { data } }),
    error: () => defineAction({ type: GET_TRENDING_GIFS.ERROR }),
};

export const getSearchedGifs = {
    start: ({ meta }) => defineAction({ type: GET_SEARCHED_GIFS.START, meta }),
    success: ({ meta, data }) =>
        defineAction({ type: GET_SEARCHED_GIFS.SUCCESS, meta, payload: { data } }),
    error: () => defineAction({ type: GET_SEARCHED_GIFS.ERROR }),
};


export const setLinkIframe = {
  start: link =>
    defineAction({
      type: SET_LINK_IFRAME.START,
      payload: {
        link,
      },
    }),
  success: () => {
    return defineAction({
      type: SET_LINK_IFRAME.SUCCESS,
    });
  },
  error: () =>
    defineAction({
      type: SET_LINK_IFRAME.ERROR,
    }),
};

export const resetNetworkDelay = () => {
  return defineAction({
    type: RESET_NETWORK_DELAY,
  });
};

export const setClientSentTime = sentTime => {
  return defineAction({
    type: SET_CLIENT_SENT_TIME,
    payload: { sentTime },
  });
};

export const setServerResponseTime = responseTime => {
  return defineAction({
    type: SET_SERVER_RESPONSE_TIME,
    payload: { responseTime },
  });
};

export const setShowTyping = isTyping => {
  return defineAction({
    type: SET_SHOW_TYPING,
    payload: { isTyping },
  });
};

export const setShowTypingIndicator = showTypingIndicator => {
  return defineAction({
    type: SHOW_TYPING_INDICATOR,
    payload: { showTypingIndicator },
  });
};

export const setNotificationRead = data =>
  defineAction({
    type: SET_READ_NOTIFICATION,
    meta: {
      data,
    },
  });

export const setTextAreaNumberOfLines = data =>
  defineAction({
    type: TEXT_AREA_NUMBER_OF_LINES,
    payload: {
      data,
    },
  });

export const clearBotActivePath = payload =>
  defineAction({
    type: CLEAR_BOT_ACTIVE_PATH,
    payload: {
      value: payload,
    },
  });

export const setAgentMessageList = data =>
  defineAction({
    type: SET_AGENT_NEW_MESSAGE_LIST,
    meta: {
      data,
    },
  });

export const setActivePage = {
  start: page =>
    defineAction({
      type: SET_ACTIVE_PAGE.START,
      meta: {
        page,
      },
    }),
  success: page => {
    return defineAction({
      type: SET_ACTIVE_PAGE.SUCCESS,
      meta: {
        page,
      },
    });
  },
  error: error =>
    defineAction({
      type: SET_ACTIVE_PAGE.ERROR,
      payload: {
        error,
      },
    }),
};
export const getInitialState = {
  start: () =>
    defineAction({
      type: GET_INITIAL_STATE.START,
    }),
  success: ({ data }) =>
    defineAction({
      type: GET_INITIAL_STATE.SUCCESS,
      payload: {
        data,
      },
    }),
  error: error =>
    defineAction({
      type: GET_INITIAL_STATE.ERROR,
      payload: {
        error,
      },
    }),
};

export const getChannelId = {
  start: ({ meta }) =>
      defineAction({
          type: GET_CHANNEL_ID.START,
          meta,
      }),
  success: ({ data }) =>
      defineAction({
          type: GET_CHANNEL_ID.SUCCESS,
          payload: {
              data,
          },
      }),
  error: error =>
      defineAction({
          type: GET_CHANNEL_ID.ERROR,
          payload: {
              error,
          },
      }),
};

export const setPage = page =>
  defineAction({
    type: SET_PAGE,
    meta: {
      page,
    },
  });

export const setSendGreetingMessageAction = message =>
    defineAction({
        type: SET_SEND_GREETING_MESSAGE_ACTION,
        meta: {
            message,
        },
    });

export const setWidgetSoundStatus = status =>
  defineAction({
    type: WIDGET_SOUND,
    meta: {
      status,
    },
  });

export const setIsMessageUnread = status =>
  defineAction({
    type: SET_IS_MESSAGE_UNREAD,
    payload: {
      status,
    },
  });

export const setIsPusherConnected = status =>
    defineAction({
        type: SET_IS_PUSHER_CONNECTED,
        payload: {
            status,
        }
    });

export const setUserId = userId =>
  defineAction({
    type: SET_USER_ID,
    payload: {
      ...userId,
    },
  });

export const setPrimaryColor = ({primaryColor}) =>
    defineAction({
        type: SET_PRIMARY_COLOR,
        payload: {
            primaryColor,
        },
    });

export const setSecondaryColor = ({secondaryColor}) =>
    defineAction({
        type: SET_SECONDARY_COLOR,
        payload: {
            secondaryColor,
        },
    });

export const setLogoUrl = logoUrl =>
    defineAction({
        type: SET_LOGO_URL,
        payload: {
            logoUrl,
        },
    });

export const setLanguage = language =>
    defineAction({
        type: SET_LANGUAGE,
        payload: {
            language,
        },
    });

export const setBotName = botName =>
  defineAction({
    type: SET_BOT_NAME,
    payload: {
        ...botName,
    },
  });

export const setHideCompanyDetailsInWidget = hideCompanyDetailsInWidget =>
    defineAction({
        type: SET_HIDE_COMPANY_DETAILS_IN_WIDGET,
        payload: {
            ...hideCompanyDetailsInWidget,
        },
    });

export const getUser = {
  start: ({ meta }) =>
    defineAction({
      type: GET_USER.START,
      meta,
    }),
  success: ({ data }) =>
    defineAction({
      type: GET_USER.SUCCESS,
      payload: {
        data,
      },
      meta: {},
    }),
  error: error =>
    defineAction({
      type: GET_USER.ERROR,
      payload: {
        error,
      },
    }),
};


export const getAllFiles = {
    start: ({ meta }) =>
        defineAction({
            type: GET_ALL_FILES.START,
            meta,
        }),
    success: ({ data }) =>
        defineAction({
            type: GET_ALL_FILES.SUCCESS,
            payload: {
                data,
            },
            meta: {},
        }),
    error: error =>
        defineAction({
            type: GET_ALL_FILES.ERROR,
            payload: {
                error,
            },
        }),
};

export const setUserAttachments = ({ attachments }) =>
    defineAction({
        type: SET_USER_ATTACHMENTS,
        payload: {
            attachments: attachments,
        },
    });

export const hideRestartButton = ({hideRestartButton}) => {
    return defineAction({
        type: HIDE_RESTART_BUTTON,
        payload: {
            hideRestartButton
        }
    });
}

export const getUserConversationsList = {
  start: () =>
    defineAction({
      type: GET_USER_CONVERSATIONS_LIST.START,
    }),
  success: ({ data }) =>
    defineAction({
      type: GET_USER_CONVERSATIONS_LIST.SUCCESS,
      payload: {
        data,
      },
    }),
  error: error =>
    defineAction({
      type: GET_USER_CONVERSATIONS_LIST.ERROR,
      payload: {
        error,
      },
    }),
};

export const createNewConversation = {
  start: () =>
    defineAction({
      type: CREATE_NEW_CONVERSATION.START,
    }),
  success: ({ data }) =>
    defineAction({
      type: CREATE_NEW_CONVERSATION.SUCCESS,
      payload: {
        data,
      },
    }),
  error: error =>
    defineAction({
      type: CREATE_NEW_CONVERSATION.ERROR,
      payload: {
        error,
      },
    }),
};

export const getUserConversation = {
  start: ({ meta }) =>
    defineAction({
      type: GET_USER_CONVERSATION.START,
      meta,
    }),
  success: ({ data }) =>
    defineAction({
      type: GET_USER_CONVERSATION.SUCCESS,
      payload: {
        data,
      },
    }),
  error: ({ error }) =>
    defineAction({
      type: GET_USER_CONVERSATION.ERROR,
      payload: {
        error,
      },
    }),
};

export const updateConversationMessages = {
  start: ({ meta }) => {
    return defineAction({
      type: UPDATE_CONVERSATION_MESSAGES.START,
      meta,
    });
  },
  success: ({ messages }) =>
    defineAction({
      type: UPDATE_CONVERSATION_MESSAGES.SUCCESS,
      payload: {
        messages,
      },
    }),
};

export const removeFromConversationMessages = {
    start: ({meta}) => {
        return defineAction({
            type: REMOVE_FROM_CONVERSATION_MESSAGES.START,
            meta,
        });
    },
    success: ({ messages }) =>
        defineAction({
            type: REMOVE_FROM_CONVERSATION_MESSAGES.SUCCESS,
            payload: {
                messages,
            },
        }),
};

export const hideRemovableMessage = {
    start: ({meta}) => {
        return defineAction({
            type:HIDE_REMOVABLE_MESSAGES.START,
            meta
        })
    },
};

export const setCurrentChannel = ({ channelId }) => {
  return defineAction({
    type: SET_CURRENT_CHANNEL,
    payload: {
      channelId,
    },
  });
};

export const setInitiateSocketConnection = ({ InitiateSocketConnection }) => {
    return defineAction({
        type: SET_INITIATE_SOCKET_CONNECTION,
        payload: {
            InitiateSocketConnection,
        },
    });
};

export const clearUserConversation = () => {
  return defineAction({
    type: CLEAR_USER_CONVERSATION,
  });
};

export const setDelayFlag = flag => {
    return defineAction({
        type: SET_DELAY_FLAG,
        payload: {
            flag,
        },
    });
};

export const setServerMessagesQueue = messageQueue => {
  return defineAction({
      type: SET_SERVER_MESSAGES_QUEUE,
      payload: {
          messageQueue,
      },
  });
};

export const setUserConversationData = ({ data }) => {
  return defineAction({
    type: SET_USER_CONVERSATION_DATA,
    payload: {
      data,
    },
  });
};

export const processPusherMessages = ({ meta }) => {
  return defineAction({
    type: PROCESS_PUSHER_MESSAGES,
    meta,
  });
};

export const processClientMessages = ({ meta }) => {
    return defineAction({
        type: PROCESS_CLIENT_MESSAGES,
        meta,
    });
};

export const setNetworkStatus = ({ data }) => {
  return defineAction({
    type: SET_NETWORK_STATUS,
    payload: {
      data,
    },
  });
};

export const updateSendingMessages = {
  start: ({ meta }) =>
    defineAction({
      type: UPDATE_SENDING_MESSAGES.START,
      meta,
    }),
  success: ({ data }) =>
    defineAction({
      type: UPDATE_SENDING_MESSAGES.SUCCESS,
      payload: {
        data,
      },
    }),
  error: ({ error }) =>
    defineAction({
      type: UPDATE_SENDING_MESSAGES.ERROR,
      payload: {
        error,
      },
    }),
};

export const removeFromSendingMessages = ({ meta }) => {
  return defineAction({
    type: REMOVE_FROM_SENDING_MESSAGES,
    meta,
  });
};

export const handleSendingMessagesToPusher = ({ meta }) => {
  return defineAction({
    type: meta?.data?.type === "cookies" ? HANDLE_SENDING_COOKIES_TO_PUSHER : HANDLE_SENDING_MESSAGES_TO_PUSHER,
    meta,
  });
};

export const updateMessageReadStatus = () => {
  return defineAction({
    type: UPDATE_MESSAGE_READ_STATUS,
  });
};

export const updateMessageDelivered = () => {
  return defineAction({
    type: UPDATE_MESSAGE_DELIVERED,
  });
};

export const clearActiveMessages = () => {
  return defineAction({
    type: CLEAR_ACTIVE_MESSAGES,
  });
};

export const setParentInnerWith = ({ meta }) => {
  return defineAction({
    type: SET_PARENT_INNER_WIDTH,
    meta,
  });
};

export const setPopupToNotificationMessage = ({ message }) => {
  return defineAction({
    type: SET_POPUP_TO_NOTIFICATION_MESSAGE,
    payload: {
      message,
    },
  });
};

export const setInputBoxStatus = ({ status }) => {
  return defineAction({
    type: SET_INPUT_BOX_STATUS,
    payload: { status },
  });
};

export const setAgent = ({ agent }) => {
  return defineAction({
    type: SET_AGENT,
    payload: { agent },
  });
};

export const setExternalTriggerForms = ({ forms }) => {
  return defineAction({
    type: SET_EXTERNAL_TRIGGER_FORMS,
    payload: { forms },
  });
};

export const setMappedFormFields = ({formFields}) => {
    return defineAction({
        type: SET_MAPPED_FORM_FIELDS,
        payload: { formFields },
    });
}

export const setCustomCookies = ({customCookies}) => {
    return defineAction({
        type: SET_CUSTOM_COOKIES,
        payload: { customCookies },
    });
}

export const setExternalTriggerElements = ({ elements }) => {
  return defineAction({
    type: SET_EXTERNAL_TRIGGER_ELEMENTS,
    payload: { elements },
  });
};

export const setTimeSpent = {
  start: ({ meta, payload }) =>
    defineAction({
      type: SET_TIME_SPENT.START,
      meta,
      payload,
    }),
  success: () =>
    defineAction({
      type: SET_TIME_SPENT.SUCCESS,
    }),
  error: error =>
    defineAction({
      type: SET_TIME_SPENT.ERROR,
      payload: {
        error,
      },
    }),
};

export const setWidgetVisibility = ({ meta }) => {
  return defineAction({
    type: SET_WIDGET_VISIBILITY,
    meta,
  });
};

export const handleWidgetEvent = ({ meta }) => {
  return defineAction({
    type: HANDLE_WIDGET_EVENT,
    meta,
  });
};
